<!--
 * @Description: 半导体行业：方案优势
-->
<template>
  <div class="semiconductor_advantage rn-section-gap">
    <section>
      <div class="container">
        <SectionTitle
          :title="$t('solution.advantages_title')"
          description="ADVANTAGES"
          textAlign="center"
        />
        <div class="semiconductor_content">
          <div class="advantage_content">
            <div
              v-for="(item, index) in list"
              :key="index"
              class="advantage_card advantage_position position"
            >
              <div class="advantage_position d_title">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import SectionTitle from '@/components/elements/sectionTitle/SectionTitle'
export default {
  name: 'SemiconductorAdvantage',
  components: { SectionTitle },
  props: {

  },
  data () {
    return {
      list: [
        { title: this.$t('solution.semiconductor.advantages.tab.tab01') },
        { title: this.$t('solution.semiconductor.advantages.tab.tab02') },
        { title: this.$t('solution.semiconductor.advantages.tab.tab03') },
        { title: this.$t('solution.semiconductor.advantages.tab.tab04') },
        { title: this.$t('solution.semiconductor.advantages.tab.tab05') },
      ]
    }
  },
  methods: {

  }
}
</script>